const abbreviations = {
  Sec: 'Section',
  IPC: 'Indian Penal Code 1860',
  CrPC: 'Code of Criminal Procedure 1973',
  CPC: 'Code of Civil Procedure',
  NI: 'Negotiable Instruments Act 1881',
  SC: 'Supreme Court',
  HC: 'High Court',
  FIR: 'First Information Report',
  IO: 'Investigating Officer',
  DGP: 'Director General of Police',
  LPA: 'Letters Patent Appeal',
  NIA: 'National Investigation Agency',
  CBI: 'Central Bureau of Investigation',
  ED: 'Enforcement Directorate',
  RTI: 'Right to Information',
  NGT: 'National Green Tribunal',
  PIL: 'Public Interest Litigation',
  UAPA: 'Unlawful Activities (Prevention) Act',
  POTA: 'Prevention of Terrorism Act',
  TADA: 'Terrorist and Disruptive Activities (Prevention) Act',
  GST: 'Goods and Services Tax',
  CGST: 'Central Goods and Services Act',
  HMA: 'Hindu Marriage Act',
  HSA: 'Hindu Succession Act',
  MVA: 'Motor Vehicles Act',
  'PC Act': 'Prevention of Corruption Act',
  NDPS: 'Narcotic Drugs and Psychotropic Substances Act',
  ADR: 'Alternate Dispute Resolution',
  'JJ Act': 'Juvenile Justice (Care and Protection of Children) Act',
  'DV Act': 'Protection of Women from Domestic Violence Act',
  BNSS: 'Bharatiya Nagarik Suraksha Sanhita 2023',
  BSA: 'Bharatiya Sakshya Adhiniyam 2023',
  BNS: 'Bharatiya Nyaya Sanhita 2023',
  POCSO: 'Protection of Children from Sexual Offences Act 2012',
  TOPA: 'Transfer of Property Act',
  // ----------------------------------
  sec: 'Section',
  ipc: 'Indian Penal Code 1860',
  crpc: 'Code of Criminal Procedure 1973',
  cpc: 'Code of Civil Procedure',
  ni: 'Negotiable Instruments Act 1881',
  sc: 'Supreme Court',
  hc: 'High Court',
  fir: 'First Information Report',
  io: 'Investigating Officer',
  dgp: 'Director General of Police',
  lpa: 'Letters Patent Appeal',
  nia: 'National Investigation Agency',
  cbi: 'Central Bureau of Investigation',
  ed: 'Enforcement Directorate',
  rti: 'Right to Information',
  ngt: 'National Green Tribunal',
  pil: 'Public Interest Litigation',
  uapa: 'Unlawful Activities (Prevention) Act',
  pota: 'Prevention of Terrorism Act',
  tada: 'Terrorist and Disruptive Activities (Prevention) Act',
  gst: 'Goods and Services Tax',
  cgst: 'Central Goods and Services Act',
  hma: 'Hindu Marriage Act',
  hsa: 'Hindu Succession Act',
  mva: 'Motor Vehicles Act',
  'pc act': 'Prevention of Corruption Act',
  ndps: 'Narcotic Drugs and Psychotropic Substances Act',
  adr: 'Alternate Dispute Resolution',
  'jj act': 'Juvenile Justice (Care and Protection of Children) Act',
  'dv act': 'Protection of Women from Domestic Violence Act',
  bnss: 'Bharatiya Nagarik Suraksha Sanhita 2023',
  bsa: 'Bharatiya Sakshya Adhiniyam 2023',
  bns: 'Bharatiya Nyaya Sanhita 2023',
  pocs: 'Protection of Children from Sexual Offences Act 2012',
  topa: 'Transfer of Property Act',
}

export default abbreviations
